import type { CashbookCategory, CashbookFundingSourcePostable } from '@finvox/shared/cashbook';
import { useTranslation } from 'react-i18next';
import {
  CashbookQuickAdd,
  type CashbookDrawerExpenseLine,
  type CashbookDrawerPriorLine,
  type CashbookIncomeMode
} from '@/components/cashbook/CashbookQuickAdd';
import { Card } from '@/components/ui/Card';

type Props = {
  open: boolean;
  onClose: () => void;
  type: 'in' | 'out';
  amount: string;
  categoryKey: string;
  date: string;
  memo: string;
  fundingSource: CashbookFundingSourcePostable | '';
  incomeMode: CashbookIncomeMode | '';
  todayDate: string;
  minDate?: string;
  customCategories?: CashbookCategory[];
  drawerPriorLines?: CashbookDrawerPriorLine[];
  drawerPriorSum?: string;
  drawerExpenseSum?: string;
  drawerExpenseLines?: CashbookDrawerExpenseLine[];
  drawerBlockedReason?: 'payvox' | 'manual_sales' | null;
  busy: boolean;
  disabled: boolean;
  onTypeChange: (t: 'in' | 'out') => void;
  onAmountChange: (v: string) => void;
  onCategoryChange: (v: string) => void;
  onDateChange: (v: string) => void;
  onMemoChange: (v: string) => void;
  onFundingSourceChange: (v: CashbookFundingSourcePostable) => void;
  onIncomeModeChange: (v: CashbookIncomeMode) => void;
  onAdd: () => void | Promise<void>;
};

export function CashbookAddRecordDialog({ open, onClose, ...formProps }: Props) {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cashbook-add-record-title"
    >
      <Card className="flex max-h-[90vh] w-full max-w-3xl flex-col overflow-hidden p-6 shadow-lg">
        <h2 id="cashbook-add-record-title" className="shrink-0 text-lg font-semibold">
          {t('cashbook.addRecordTitle')}
        </h2>
        <div className="mt-4 min-h-0 flex-1 overflow-y-auto">
          <CashbookQuickAdd embedded onCancel={onClose} {...formProps} />
        </div>
      </Card>
    </div>
  );
}
